module.exports = __webpack_public_path__ + "static/media/dumbell.a5b671a0.svg";